<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/9AELNA/tc-custom/9781459206724.jpg?1718183455060" alt="This image is the cover for the book Convenient Proposal, Marry Me?"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Convenient Proposal, Marry Me?
      </h1>
      <p class="bookDescription body article font2">
        <p>Candy was wary when Quinn Ellington suggested it would be mutually beneficial for them to marry. She knew her uncle had asked Quinn to look after her while she recovered from an accident. But wasn’t marriage taking it a bit far?<br/><br/>Quinn claimed he needed a wife, but he didn’t strike Candy as a man who needed <i>anyone</i>! Many women had tried to get him to the alter…so what really lay behind his proposal?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Helen Brooks
      </h2>
      
      <p class="authorDescription body article">Helen Brooks began writing in 1990 as she approached her 40th birthday! She realized her two teenage ambitions (writing a novel and learning to drive) had been lost amid babies and hectic family life, so set about resurrecting them. In her spare time she enjoys sitting in her wonderfully therapeutic, rambling old garden in the sun with a glass of red wine (under the guise of resting while thinking of course). Helen lives in Northampton, England with her husband and family.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7dc96526